import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Google, Intercom } from '@helpers'
import { Loader } from '@components/UI'
import { useAuth } from '@hooks'

import { Main } from './main'

export const Auth = () => {
  const { loading, identify, setToken } = useAuth()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    Intercom.showLauncher()
    Intercom.update()
  }, [])

  useEffect(() => {
    const search = new URLSearchParams(location.search)
    const token = search.get('token')
    const next = search.get('next')

    if (!token) {
      identify()
      return
    }

    setToken(token)
    history.replace(next)
  }, [location.search, identify, setToken, history])

  useEffect(() => {
    Google.track('pageview', {
      pagePath: location.pathname
    })
  }, [location.pathname])

  return loading ? <Loader icon dark full /> : <Main />
}
